import React from 'react'

export default function Contact() {
  return (
    <div id="contact" className="h-auto md:h-screen py-24 w-screen flex justify-center items-center bg-gradient-to-br from-zinc-900 to-zinc-700">
        <div className="w-3/4 max-w-[400px] h-auto md:max-w-none md:w-auto md:h-2/3 flex flex-col md:flex-row justify-center items-center">
            <img className="h-full w-auto" src="./images/contact.jpg" alt="contact iamge"/>
            <div className="w-full md:w-auto md:h-full bg-gradient-to-b from-zinc-300 to-zinc-100 p-10">
                <h1 className="ubun text-3xl bg-gradient-to-r from-cyan-100 to-cyan-600 bg-clip-text text-transparent">Have any Query?</h1>
                <div>
                    <h3 className="mt-3 mb-2 font-semibold">Subject</h3>
                    <input id="cont-subject" className="border-none w-full p-3 text-sm focus:outline-none" type="text"/>
                    <h3 className="mt-3 mb-2 font-semibold">Body</h3>
                    <textarea id="cont-body" className="border-none w-full p-3 text-sm focus:outline-none h-16"/>
                    <button id="send" className="mt-5 bg-zinc-700 text-cyan-100 ubun p-3 transition-all hover:scale-110 active:scale-90 cursor-pointer" type="submit">Send <i className="fa-solid fa-paper-plane"></i></button>
                </div>
            </div>
        </div>
    </div>
  )
}
